module.exports = __webpack_public_path__ + "media/images/emoticons/sharp-582ea4bad98d457c8ab74abc447cdafb.gif";